export default "__VITE_ASSET__BE7X1Ucj__"